import { render } from "./expandInfo.vue?vue&type=template&id=3d2d79ff"
import script from "./expandInfo.vue?vue&type=script&lang=js"
export * from "./expandInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__